module.exports = __webpack_public_path__ + "img/hd4.10248685.png";